import supabase from '../config/supabaseClient';

export const createSecurityClass = async (securityClassData) => {
    const { security_type, security_code, security_category, shares_reserved, security_class_label, ...otherFields } = securityClassData;
    
    console.log('Attempting to create security class with data:', {
      security_type,
      security_code,
      shares_reserved,
      security_class_label,
      security_category,
      ...otherFields
    });
    
    try {
      // Check if the security class label already exists
      const { data: existingClasses, error: fetchError } = await supabase
        .from('securities_classes')
        .select('security_class_label')
        .eq('security_class_label', security_class_label);
  
      console.log('Duplicate check result:', { existingClasses, fetchError });
  
      if (fetchError) {
        throw fetchError;
      }
  
      if (existingClasses && existingClasses.length > 0) {
        throw new Error(`Security class label "${security_class_label}" already exists.`);
      }
  
      // Prepare the insert data
      const insertData = {
        security_type,
        security_category,
        security_code,
        security_class_label,
        shares_reserved,
        ...otherFields,
        created_at: new Date(),
      };
      
      console.log('Inserting data:', insertData);
  
      // Insert the new security class
      const { data, error } = await supabase
        .from('securities_classes')
        .insert([insertData]);
  
      console.log('Insert result:', { data, error });
  
      if (error) {
        throw error;
      }
  
      return { data, error: null }; 
    } catch (error) {
      console.error('Error creating security class:', error);
      return { data: null, error: { message: error.message || 'Unknown error' } };
    }
  };

  // Fetch security classes
export const fetchSecurityClasses = async () => {
  const { data, error } = await supabase
    .from('securities_classes')
    .select(`
      id,
      security_type,
      security_category,
      security_code,
      security_class_label,
      shares_reserved,
      created_at`); 

  if (error) {
    console.error('Error fetching security classes:', error);
    return [];
  }

  return data;
};

  // Fetch security classes
  export const fetchShareholders = async () => {
    const { data, error } = await supabase
      .from('securities_grants')
      .select(`
        id,
        shareholder,
        shares_issued,
        price_per_share,
        capital_committed,
        share_name,
        security_class_id,
        created_at`); 
  
    if (error) {
      console.error('Error fetching security classes:', error);
      return [];
    }
  
    return data;
  };
  
export const createSecurityGrants = async (securityGrantData) => {
  try {
    // Make sure the required fields are present
    const { 
      shareholder, 
      shares_issued, 
      price_per_share, 
      capital_committed, 
      share_name, 
      vesting_schedule, 
      security_class_id 
    } = securityGrantData;

    if (!shareholder || !shares_issued || !price_per_share || !capital_committed || !share_name || vesting_schedule === undefined || !security_class_id) {
      throw new Error('All fields are required');
    }

    // Insert the data into Supabase
    const { data, error } = await supabase
      .from('securities_grants')  // Table name
      .insert([
        {
          shareholder,
          shares_issued,
          price_per_share,
          capital_committed,
          share_name,
          vesting_schedule: vesting_schedule === 'Yes', // Convert Yes/No to boolean
          security_class_id
        },
      ]);

    // Handle errors if any
    if (error) {
      throw error;
    }

    // Return the data and null error if successful
    console.log('Security Grant created:', data);
    return { data, error: null };
  } catch (error) {
    console.error('Error creating security grant:', error);
    return { data: null, error };  // Return error if any
  }
};
